import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ChickletHoverButton = ({
  dataSeleniumTest,
  dataTestId,
  disabled = false,
  disabledMessage,
  href,
  label,
  onClick
}) => {
  return typeof label === 'string' ? /*#__PURE__*/_jsx(Tooltip, {
    title: disabled && disabledMessage,
    disabled: !disabled,
    placement: "left",
    children: /*#__PURE__*/_jsx(Button, {
      "data-selenium-test": dataSeleniumTest,
      "data-test-id": dataTestId,
      href: href,
      external: !!href,
      onClick: onClick,
      use: "tertiary",
      size: "xs",
      disabled: disabled,
      children: label
    })
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: label
  });
};
export default ChickletHoverButton;